import { Icon, Text, TextLink } from '@oneaudi/unified-web-components';
import { useI18n } from '~/app/i18n/i18n';
import {
	ListItemStyle,
	ListStyle,
	TyreLabelStyle,
} from '~/app/pages/configurator/components/dialogs/car-matching-results-dialog/styles/tyre-label-styles';
import { ConfiguredCarFeature } from '~/graphql/__generated__/graphql';

export function EuTyreLabel({ tyreLabels }: { tyreLabels: NonNullable<ConfiguredCarFeature['tyreLabels']> }) {
	const { i18n } = useI18n();
	const tireLabelUrl = i18n('ngc.dialogs.euTyreLabel.linkURL');

	return (
		<TyreLabelStyle>
			{tireLabelUrl && (
				<>
					<Text variant={{ type: 'copy', order: '1', style: 'bold' }}>
						{i18n('ngc.dialogs.euTyreLabel.linkText')}
					</Text>

					<TextLink
						variant="standalone"
						href={tireLabelUrl}
						size="md"
						target="_blank"
						iconPosition={'trailing'}
						icon={'forward'}>
						{i18n('ngc.dialogs.euTyreLabel.linkText')}
					</TextLink>
				</>
			)}
			{/* eslint-disable-next-line */}
			<section tabIndex={0} className="disclaimer">
				<Icon name={'info-circle'} size="s" />
				<Text variant={{ type: 'copy', order: '1', style: 'normal' }}>
					{i18n('ngc.dialogs.euTyreLabel.disclaimer')}
				</Text>
			</section>

			{tyreLabels.length > 0 && (
				<ListStyle>
					{tyreLabels.map((label) => (
						<ListItemStyle key={label?.productSheetUrl}>
							<figure role="group">
								{label?.tyreLabelUrl && (
									<img
										/* eslint-disable-next-line */
										tabIndex={0}
										src={label.tyreLabelUrl}
										alt={i18n('ngc.dialogs.euTyreLabel.description')}
									/>
								)}
								{label?.productSheetUrl && (
									<figcaption>
										<TextLink
											size="md"
											variant="standalone"
											href={label.productSheetUrl}
											target="_blank"
											iconPosition={'trailing'}
											icon={'forward'}>
											{i18n('ngc.actions.productDataSheet')}
										</TextLink>
									</figcaption>
								)}
							</figure>
						</ListItemStyle>
					))}
				</ListStyle>
			)}
		</TyreLabelStyle>
	);
}
